import { Controller } from "@hotwired/stimulus"

const PREFIX = "https://"

export default class extends Controller {
  connect() {
    this.ensurePrefix()
    this.element.addEventListener("keydown", this.onKeyDown)
    this.element.addEventListener("input", this.onInput)
    this.element.addEventListener("focus", this.onFocus)
    this.element.addEventListener("click", this.onClick)
  }

  disconnect() {
    this.element.removeEventListener("keydown", this.onKeyDown)
    this.element.removeEventListener("input", this.onInput)
    this.element.removeEventListener("focus", this.onFocus)
    this.element.removeEventListener("click", this.onClick)
  }

  ensurePrefix() {
    if (!this.element.value.startsWith(PREFIX)) {
      this.element.value = PREFIX + this.stripPrefix(this.element.value)
    }
  }

  stripPrefix(value) {
    return value.replace(/^https?:\/\//, "")
  }

  onFocus = () => {
    this.ensurePrefix()
    this.moveCursorToEnd()
  }

  onClick = () => {
    if (this.element.selectionStart < PREFIX.length) {
      this.moveCursorToEndOfPrefix()
    }
  }

  onKeyDown = (event) => {
    const pos = this.element.selectionStart
    const selectionLength = this.element.selectionEnd - this.element.selectionStart

    if (
      (event.key === "Backspace" && pos <= PREFIX.length && selectionLength === 0) ||
      (event.key === "Delete" && pos < PREFIX.length) ||
      (event.key === "ArrowLeft" && pos === PREFIX.length)
    ) {
      event.preventDefault()
      this.moveCursorToEndOfPrefix()
    }
  }

  onInput = () => {
    let value = this.element.value

    if (value === "" || value.length < PREFIX.length) {
      this.element.value = PREFIX
      this.moveCursorToEnd()
      return
    }

    if (!value.startsWith(PREFIX)) {
      const rest = this.stripPrefix(value)
      this.element.value = PREFIX + rest
    }

    if (this.element.selectionStart < PREFIX.length) {
      this.moveCursorToEndOfPrefix()
    }
  }

  moveCursorToEndOfPrefix() {
    this.element.setSelectionRange(PREFIX.length, PREFIX.length)
  }

  moveCursorToEnd() {
    const len = this.element.value.length
    this.element.setSelectionRange(len, len)
  }
}
